import type { ParsedUrlQuery } from 'querystring';

import type { DocumentInput } from 'urql';

import { queryData } from '@/core/graphqlClient/queryClient';
import { getPlatform, isB2B } from '@/core/settings/utils';
import { type Market, type Platform } from '@/generated/graphql/types';
import { PlainQueryParams } from '@/productDiscovery/Listings/interfaces/algolia';
import { SponsoredProductsLocationType } from '@/productDiscovery/SponsoredProducts/interfaces/SponsoredProducts';
import { processSponsoredProducts } from '@/productDiscovery/SponsoredProducts/utils/processSponsoredProducts';
import { generateFilters } from '@/sellerAdsManagement/SponsoredProducts/utils/generateFilters';

import {
  SpDataMassLandingPageDocument,
  SpDataSearchBarDocument,
  SpDataSearchPageDocument,
} from './graphql/SpDataByQuery/generated/spDataByQuery.query.generated';

export const fetchSpDataByQuery = (
  query: string,
  location: SponsoredProductsLocationType,
  queryDocument: DocumentInput,
  queryParams?: ParsedUrlQuery | PlainQueryParams,
  abt?: string,
) => {
  let filters = {};

  if (queryParams) {
    filters = generateFilters(queryParams);
  }
  return queryData(queryDocument, {
    context: {
      market: (isB2B() ? 'B2B' : 'B2C') as Market,
      platform: getPlatform().toUpperCase() as Platform,
      device: 'DESKTOP',
      location,
      abt: abt || null,
    },
    query,
    filters: Object.keys(filters).length === 0 ? null : filters,
  }).then((result: any) => {
    if (result && result.sProducts && result.sProducts.listByQuery) {
      return processSponsoredProducts(result.sProducts.listByQuery);
    }
    return null;
  });
};

export const fetchSpDataSearchBar = (
  query: string,
  queryParams?: ParsedUrlQuery | PlainQueryParams,
  abt?: string,
) =>
  fetchSpDataByQuery(
    query,
    SponsoredProductsLocationType.SEARCH_BAR,
    SpDataSearchBarDocument,
    queryParams,
    abt,
  );

export const fetchSpDataSearchPage = (
  query: string,
  queryParams?: ParsedUrlQuery | PlainQueryParams,
  abt?: string,
) =>
  fetchSpDataByQuery(
    query,
    SponsoredProductsLocationType.SEARCH_PAGE,
    SpDataSearchPageDocument,
    queryParams,
    abt,
  );

export const fetchSpDataMassLandingPage = (
  query: string,
  queryParams?: ParsedUrlQuery | PlainQueryParams,
  abt?: string,
) =>
  fetchSpDataByQuery(
    query,
    SponsoredProductsLocationType.MASS_LANDING_PAGE,
    SpDataMassLandingPageDocument,
    queryParams,
    abt,
  );
